export default __webpack_public_path__ + "static/logo-without-text-0d2ea1c6ccf4771e675bfbdfc87be70d.png";